import type { ModuleKey } from '@risksmart-app/modules/src/index';
import { isModuleEnabled } from '@risksmart-app/modules/src/index';
import { useCallback } from 'react';
import { useModulesStore } from 'src/context/moduleContext';

/**
 * Hook to check if a module is enabled for the current organisation.
 * The module tree is always authoritative.
 *
 * @param moduleKey Dot-notation module path, e.g. 'risk.subModules.appetite'
 */
export const useIsModuleEnabled = (moduleKey: ModuleKey): boolean => {
  const { modules } = useModulesStore();

  return isModuleEnabled(modules, moduleKey);
};

/**
 * Lazy variant that returns a callback for checking module enablement.
 * Useful when you need to check multiple module keys or pass the check
 * as a callback.
 */
export const useIsModuleEnabledLazy = (): ((
  moduleKey: ModuleKey
) => boolean) => {
  const { modules } = useModulesStore();

  return useCallback(
    (moduleKey: ModuleKey) => isModuleEnabled(modules, moduleKey),
    [modules]
  );
};
